import { Accordion, AccordionItem, Spinner } from '@toggle/design-system';
import { useDisableScroll } from '@toggle/helpers/src/hooks/use-disable-scroll/useDisableScroll';
import dynamic from 'next/dynamic';
import { useTranslation } from 'next-i18next';
import React from 'react';
import ReactMarkdown from 'react-markdown';

import { Faq } from '@/api/faq/faq-schema';
import { useFaqData } from '~/hooks/useFaq/useFaq';

import * as S from './FaqDrawer.styles';

interface FaqDrawerProps {
  isOpen: boolean;
  closeDrawer: () => void;
}

const FaqView = ({ isOpen, closeDrawer }: FaqDrawerProps) => {
  const { t } = useTranslation('common');
  const { data } = useFaqData();

  const mapAccordionData = (data: Faq): AccordionItem[] => {
    return data.faqs.map(faq => ({
      title: faq.question,
      content: faq.answer,
    }));
  };

  const accordionItems = data ? mapAccordionData(data) : [];

  useDisableScroll(isOpen);

  return (
    <section data-testid="faq-drawer">
      <S.StyledDrawer
        headerTitle={t('faqDrawer.title')}
        isOpen={isOpen}
        handleCloseClick={closeDrawer}
        drawerWidth={'600px'}
      >
        {data ? (
          <S.Container data-testid="faq-content">
            <ReactMarkdown
              data-testid="description"
              children={data?.description}
              components={{
                p: ({ children }) => <S.Subtitle>{children}</S.Subtitle>,
              }}
            />
            <Accordion items={accordionItems} />
          </S.Container>
        ) : (
          <S.SpinnerContainer data-testid="faq-spinner">
            <Spinner />
          </S.SpinnerContainer>
        )}
      </S.StyledDrawer>
    </section>
  );
};

export const FaqDrawer = dynamic({
  ssr: false,
  loader: () => Promise.resolve(FaqView),
});
